import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="checkpoints"
export default class extends Controller {
  static targets = ["inputDate", "link"];
  static values = { eventId: Number };

  declare inputDateTarget: HTMLInputElement;
  declare hasInputDateTarget: boolean;
  declare linkTarget: HTMLAnchorElement;
  declare hasLinkTarget: boolean;

  connect() {}

  loadSlots() {
    const date = this.hasInputDateTarget ? this.inputDateTarget.value : null;
    if (!date || !this.hasLinkTarget) return;

    this.linkTarget.href = this.linkTarget.href.split("date=")[0];
    this.linkTarget.href += `date=${date}`;
    this.linkTarget.click();
  }
}
